import { render } from "./Home.vue?vue&type=template&id=021b31f6&bindings={\"eDevletLoginUrl\":\"data\",\"showEdevletLogin\":\"data\",\"cards\":\"data\",\"startPayload\":\"data\",\"start\":\"options\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script